import { action } from "satcheljs";
import { Moment } from "moment";

const getScheduleDataInCustomDateRange = action(
    "GET_SCHEDULE_DATA_IN_CUSTOM_DATE_RANGE",
    (
        startDate: Moment,
        endDate: Moment,
        forceLoad: boolean = true
    ) => ({
        startDate: startDate,
        endDate: endDate,
        forceLoad: forceLoad
    })
);

export default getScheduleDataInCustomDateRange;